import { ref } from "vue";
import { defineStore } from "pinia";
import { useHttpStore } from "@/stores/http";

export const useUserStore = defineStore("user", () => {
  const httpStore = useHttpStore();

  const toggleUserStatus = (userId, newStatus) => {

    var params = {
      userId,
      newStatus
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api('post', "users/ToggleUserStatus", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getOrganizationUsers = () => {
    var params = {
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "users/GetOrganizationUsers", params, {
          showLoading: true,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getAppUsersBy = (searchBy) => {
    var params = {
      searchBy: searchBy
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "users/GetAppUsersBy", params, {
          showLoading: true,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getEmptyAppUser = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "users/GetEmptyAppUser", params, {
          showLoading: true,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getUserTypes = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "users/GetUserTypes", params, {
          showLoading: true,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const toggleUserAccountState = (user) => {
    var params = {
      appUser: user
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api('post', "users/ToggleUserAccountState", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const saveUserAccount = (user) => {
    var params = {
      appUser: user
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api('post', "users/SaveUserAccount", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const resetTotpEnabled = (user) => {
    var params = {
      appUser: user
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api('post', "users/ResetTotpEnabled", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getUserId = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api('get', "users/GetUserId", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  
  return {
    getOrganizationUsers,
    toggleUserStatus,
    getAppUsersBy,
    getUserTypes,
    toggleUserAccountState,
    saveUserAccount,
    resetTotpEnabled,
    getEmptyAppUser,
    getUserId
  };
});
